import { InstantAccessProgram_Platform } from '@squareup/shared-types-protos/squareup/inflows/instant_access_program_model';

interface PlatformBranding {
  logoImageUrl: string;
  logoImageBackgroundColorCode: string;
}

const PLATFORM_BRANDING: Record<number, PlatformBranding> = {
  [InstantAccessProgram_Platform.DOORDASH]: {
    logoImageUrl:
      'https://balance-reporter-assets.s3.amazonaws.com/m_category_instant_funding_doordash.png',
    logoImageBackgroundColorCode: '#FF3008',
  },
  [InstantAccessProgram_Platform.UBER_EATS]: {
    logoImageUrl:
      'https://balance-reporter-assets.s3.amazonaws.com/m_category_instant_access_uber_eats.png',
    logoImageBackgroundColorCode: '#172327',
  },
  [InstantAccessProgram_Platform.GRUBHUB]: {
    logoImageUrl:
      'https://balance-reporter-assets.s3.amazonaws.com/m_category_instant_payouts_grubhub.png',
    logoImageBackgroundColorCode: '#FF5500',
  },
};

export function getPlatformBranding(
  platform: InstantAccessProgram_Platform | undefined,
): PlatformBranding | undefined {
  if (platform === undefined) {
    return undefined;
  }
  return PLATFORM_BRANDING[platform];
}
